import { useCallback, useMemo, useState, useRef } from "react";

const useShowReels = ({videoRefs, setPlayingMap, setMutedMap, get_stories }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedStoryId, setSelectedStoryId] = useState(null);

    const swiperRef = useRef(null);

    const handleOpenSlider = useCallback(
        (id) => {
            
            setSelectedStoryId(id);
            setIsOpen(true);
            setPlayingMap((prev) => ({ ...prev, [id]: true }));
            setMutedMap((prev) => ({ ...prev, [id]: false }));
            requestAnimationFrame(() => {
                const video = videoRefs.current[id];
                if (video) {
                    video.currentTime = 0;
                    video.play();
                    video.muted = false;
                }
            });
        },
        [setPlayingMap, videoRefs]
    );
    const handleCloseSlider = useCallback(() => {
        setIsOpen(false);
        get_stories?.forEach((story) => {
            const video = videoRefs.current[story.id];
            if (video) {
                video.pause();
                video.currentTime = 0;
                video.src = "";
            }
        });
        setPlayingMap({});
        setMutedMap({});
        setSelectedStoryId(null);
    }, [get_stories, videoRefs, selectedStoryId]);

    const initialSlideIndex = useMemo(() => {
        if (!get_stories || !selectedStoryId) return 0;
        return get_stories?.findIndex((s) => s.id === selectedStoryId) ?? 0;
    }, [get_stories, selectedStoryId]);

    const handleSlideChange = useCallback(() => {
        if (!swiperRef.current) return;

        const currentIndex = swiperRef.current.activeIndex;
        const currentStory = get_stories[currentIndex];
        if (!currentStory) return;

        get_stories?.forEach((story) => {
            const video = videoRefs.current[story.id];
            if (!video) return;

            if (story.id === currentStory.id) {
                video.currentTime = 0;
                video.play().catch(() => { });
                setPlayingMap((prev) => ({ ...prev, [story.id]: true }));
                setMutedMap((prev) => ({ ...prev, [story.id]: false }));
            } else {
                video.pause();
                video.currentTime = 0;
                setPlayingMap((prev) => ({ ...prev, [story.id]: false }));
                setMutedMap((prev) => ({ ...prev, [story.id]: true }));
            }
        });
    }, [get_stories, videoRefs, setPlayingMap, setMutedMap]);

    return {
        isOpen,
        swiperRef,
        initialSlideIndex,
        handleOpenSlider,
        handleCloseSlider,
        handleSlideChange,
    };
}

export default useShowReels